import { gql } from "@apollo/client";
import { jssaQuery } from "./index";
import { CostPayoutModifier } from "../../../common/models";
import { costPayoutModifierAllFieldsFragment } from "./CommonQueries";
import { CostPayoutModifierInput } from "../../../common/inputs/CostPayoutModifierInput";

export const allCostPayoutModifiersQuery = gql`
    ${costPayoutModifierAllFieldsFragment}
    query allCostPayoutModifiers($options: CostPayoutModifierInput) {
        allCostPayoutModifiers(options: $options) {
            ...CostPayoutModifierAllFields
        }
    }
`;

export const queryAllCostPayoutModifiers = async (options?: CostPayoutModifierInput): Promise<CostPayoutModifier[]> => {
    const { data: { allCostPayoutModifiers } } = await jssaQuery({
        query: allCostPayoutModifiersQuery,
        variables: { options },
    });
    return allCostPayoutModifiers;
};
